import { ApiService } from '@b2b/common/services/api/types';
import { AuthenticationService, AuthenticationServiceModule } from '@b2b/common/services/auth/authentication.service';
import uiRouter, { StateParams, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ResetPasswordControllerModule } from './controllers/ResetPasswordController';
import { ResetPasswordExpiredControllerModule } from './controllers/ResetPasswordExpiredController';

export const ResetPasswordView = angular
  .module('acme.view.resetPassword', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    AuthenticationServiceModule,
    ResetPasswordControllerModule,
    ResetPasswordExpiredControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'resetPassword',
      url: '/resetPassword',
      abstract: true,
      views: {
        main: {
          templateUrl: 'layouts/standard.tpl.html',
        },
      },
    });

    $stateProvider.state({
      name: 'resetPassword.passwordExpired',
      url: '',
      params: {
        email: { value: null, squash: true },
        oldPassword: { value: null, squash: true },
        error: { value: null, squash: true },
      },
      views: {
        'subview-main': {
          controller: 'ResetPasswordExpiredController',
          templateUrl: 'views/resetPassword/reset-password-expired.tpl.html',
        },
      },
      data: {
        pageTitle: 'Reset Your Password',
      },
      resolve: {
        LogoutData: [
          'AuthenticationService',
          function (authenticationService: AuthenticationService) {
            return authenticationService.logout().catch((response) => response);
          },
        ],
      },
    });

    $stateProvider.state({
      name: 'resetPassword.default',
      url: '/:token',
      views: {
        'subview-main': {
          controller: 'ResetPasswordController',
          templateUrl: 'views/resetPassword/resetPassword.tpl.html',
        },
      },
      data: {
        pageTitle: 'Reset Your Password',
      },
      resolve: {
        ConfigData: [
          'ApiService',
          'AuthenticationService',
          '$stateParams',
          function (ApiService: ApiService, authenticationService: AuthenticationService, $stateParams: StateParams) {
            return authenticationService
              .logout()
              .catch((response) => response)
              .then(() => {
                return ApiService.administration.tenantConfig($stateParams.token).catch((response) => response);
              });
          },
        ],
      },
    });
  }).name;
